import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { InertiaFormField } from '@/components/ui/form';
import { Link } from '@/components/ui/link';
import { useForm } from '@inertiajs/react';
import { FormEventHandler } from 'react';

export default function RegisterForm({
  referralCode,
  onClickLogIn,
}: {
  referralCode?: string;
  onClickLogIn: () => void;
}) {
  const form = useForm({
    email: '',
    username: '',
    name: '',
    password: '',
    confirmPassword: '',
    referralCode: referralCode || '',
    phone: '',
    citizenId: '',
  });

  const submit: FormEventHandler = (e) => {
    e.preventDefault();

    form.post(route('register'), {
      onSuccess: () => form.reset('password', 'confirmPassword'),
    });
  };

  return (
    <Card className="h-fit w-full md:max-w-[20rem]">
      <CardHeader>
        <CardTitle className="text-2xl">Đăng ký</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit}>
          <div className="space-y-5">
            <InertiaFormField
              form={form}
              fieldName="username"
              displayName="ID đăng nhập"
            />
            <InertiaFormField
              form={form}
              fieldName="email"
              type="email"
              displayName="Email"
            />
            <InertiaFormField form={form} fieldName="name" displayName="Tên" />
            <InertiaFormField
              form={form}
              fieldName="password"
              type="password"
              displayName="Mật khẩu"
            />
            <InertiaFormField
              form={form}
              fieldName="confirmPassword"
              type="password"
              displayName="Xác nhận mật khẩu"
            />
            <InertiaFormField
              form={form}
              fieldName="phone"
              displayName="Số điện thoại"
            />
            <InertiaFormField
              form={form}
              fieldName="citizenId"
              displayName="CCCD"
            />
            <InertiaFormField
              form={form}
              fieldName="referralCode"
              displayName="Mã giới thiệu"
              inputProps={{
                disabled: !!referralCode,
                readOnly: !!referralCode,
              }}
            />

            <div className="w-full">
              <Button className="w-full" loading={form.processing}>
                Đăng ký
              </Button>
            </div>
          </div>
        </form>
        <p className="mt-2 text-sm text-muted-foreground">
          Đã có tài khoản? <Link onClick={onClickLogIn}>Đăng nhập</Link>
        </p>
      </CardContent>
    </Card>
  );
}
